/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Box, Flex, Text, LegacyText, Link, SystemProps } from "flicket-ui";
import { Icon } from "~components";
import { ReactNode } from "react";

interface BaseSubHeaderProps {
  title: ReactNode;
  backToLinkText: string;
  subTitle?: ReactNode;
  isSinglePage: boolean;
  backToLink: string;
  hideBackLink?: boolean;
  colour?: SystemProps["color"];
}

export const DesktopSubHeader = ({
  isSinglePage,
  backToLinkText,
  backToLink = "/",
  hideBackLink = false,
  title,
  subTitle,
  colour = "white",
}: BaseSubHeaderProps) => (
  <Box
    width="100%"
    maxWidth="1248px"
    pl={4}
    mx={"auto" as any}
    mb={1}
    display={{ _: "none", md: "block" }}
  >
    {hideBackLink ? null : (
      <Link to={backToLink}>
        <Flex alignItems="center" opacity="inherit">
          <Icon icon="chevron-left" fontSize={5} color={colour} />
          {isSinglePage ? (
            <LegacyText
              as={"h2"}
              color={colour}
              fontWeight="extraBold"
              fontSize={3}
              lineHeight="medium"
              ml="3/4"
            >
              Back to ticket selection
            </LegacyText>
          ) : (
            <LegacyText
              color={colour}
              fontWeight="extraBold"
              fontSize={3}
              lineHeight="medium"
              ml="3/4"
            >
              {backToLinkText}
            </LegacyText>
          )}
        </Flex>
      </Link>
    )}
    <LegacyText
      as={"h1"}
      color={colour}
      fontWeight="heavy"
      fontSize={9}
      lineHeight={"56px" as any}
      mt={1}
    >
      {title}
    </LegacyText>
    {subTitle && (
      <LegacyText
        color={colour}
        fontWeight="heavy"
        fontSize={5}
        lineHeight={"95%" as any}
        mb={{ _: 0, md: 3 }}
      >
        {subTitle}
      </LegacyText>
    )}
  </Box>
);
